/**
 * Created by Ivan on 10.08.2026
 */

const StickersBook2 = function () {
    cleverapps.EventEmitter.call(this);

    this.load();
};

StickersBook2.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersBook2.prototype.constructor = StickersBook2;

StickersBook2.prototype.load = function (stored) {
    const save = stored || cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK2_INFO) || {};
    const saveAttention = cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK2_ATTENTION) || [];

    this.season = typeof save.season === "string" ? save.season : undefined;
    this.version = save.version;
    this.points = save.points || 0;
    this.restarts = save.restarts || 0;
    this.finished = Boolean(save.finished);

    this.unissuedPrizesCollectionsIndexes = [];

    if (save.collections && save.collections.length) {
        for (let i = 0; i < save.collections.length; i++) {
            const value = save.collections[i];

            const isPrizeCollected = (value & 1) === 1;
            const stickerBits = value >> 1;

            const allStickersMask = (1 << StickersCollection2.STICKERS_IN_COLLECTION) - 1;
            const isFullyCollected = stickerBits === allStickersMask;

            if (isFullyCollected && !isPrizeCollected) {
                this.unissuedPrizesCollectionsIndexes.push(i);
            }
        }
    }

    this.createCollections(save, saveAttention);
};

StickersBook2.prototype.isAvailable = function () {
    return this.season !== undefined && !this.finished && levels.user.checkAvailable(cleverapps.config.availables.STICKERS_BOOK);
};

StickersBook2.prototype.isVisibleInScene = function () {
    return cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain;
};

StickersBook2.prototype.needChangeSeason = function () {
    if (!levels.user.checkAvailable(cleverapps.config.availables.STICKERS_BOOK)) {
        return false;
    }

    if (this.season === this.calcSeasonIndex()) {
        return false;
    }

    if (!this.isVisibleInScene()) {
        return false;
    }

    return this.season !== undefined || this.isEnoughBundlesForSeason();
};

StickersBook2.prototype.isEnoughBundlesForSeason = function () {
    const nextSeason = this.calcSeasonIndex();
    return SeasonCollectionsHelper2.hasSeasonBundle(nextSeason);
};

StickersBook2.prototype.updateSeason = function () {
    if (this.isAvailable()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS2_DAU);

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS2_COLLECTIONS + (this.restarts * this.collectionsAmount + this.getCompletedCollectionsAmount()), {
            key: cleverapps.EVENTS.STICKERS2_COLLECTIONS
        });
    }

    if (!this.needChangeSeason()) {
        return;
    }

    const isFirstFeatureAppearance = this.season === undefined;
    const actions = [];

    if (!isFirstFeatureAppearance && !this.finished) {
        actions.push((f) => {
            new StickersBookSeasonWindow2({ isCompleted: true });
            cleverapps.focusManager.onceNoWindowsListener = f;
        });

        const unissuedPrizes = this.getUnissuedPrizes();
        if (unissuedPrizes.length) {
            actions.push((f) => {
                new RewardWindow(unissuedPrizes, { event: cleverapps.EVENTS.EARN.STICKERS_BOOK2, toBubbleStack: true });
                cleverapps.focusManager.onceNoWindowsListener = f;
            });
        }
    }

    if (!this.isEnoughBundlesForSeason()) {
        actions.push((f) => {
            this.setSeason(undefined);
            cleverapps.toolbar.updateItems(true);

            f();
        });
    } else {
        actions.push((f) => {
            this.setSeason(this.calcSeasonIndex());
            cleverapps.toolbar.updateItems(true);
            cleverapps.eventBus.trigger("stickers2_add_fly_icon");
            f();
        });

        actions.push((f) => {
            cleverapps.tutorial.startScenario(cleverapps.tutorial.findScenario(SeasonCollectionsStartTutorial2.NAME));
            f();
        });

        if (isFirstFeatureAppearance) {
            actions.push((f) => {
                cleverapps.tutorial.startScenario(cleverapps.tutorial.findScenario(StickersBookStartTutorial2.NAME));
                f();
            });
        }
    }

    cleverapps.focusManager.display({
        focus: "StickersBookUpdateSeason",
        actions
    });
};

StickersBook2.prototype.setSeason = function (season) {
    this.season = season;
    this.restarts = 0;
    this.finished = false;
    this.createCollections();
    this.save();
    this.trigger("update");
};

StickersBook2.prototype.canRestartSeason = function () {
    return this.restarts === 0;
};

StickersBook2.prototype.restartSeason = function () {
    this.restarts++;
    this.createCollections();
    this.trigger("update");
    this.save();
};

StickersBook2.prototype.finishSeason = function () {
    this.finished = true;
    this.save();
    cleverapps.toolbar.updateItems(true);
    this.trigger("update");
};

StickersBook2.prototype.createCollections = function (save, saveAttention) {
    save = save || {};
    saveAttention = saveAttention || [];

    this.collections = [];

    this.collectionsAmount = this.calcCollectionsAmount();

    const info = save.collections || [];

    for (let i = 0; i < this.collectionsAmount; i++) {
        const collectionInfo = this.binaryToArray(info[i] || 0, StickersCollection2.STICKERS_IN_COLLECTION + 1);
        const isPrizeCollected = Boolean(collectionInfo.pop());
        const collection = new StickersCollection2({
            stickers: collectionInfo,
            isPrizeCollected,
            index: i,
            attention: this.binaryToArray(i < saveAttention.length ? saveAttention[i] : 0, StickersCollection2.STICKERS_IN_COLLECTION),
            season: this.season
        });

        collection.on("update", () => {
            this.trigger("update");
        });

        this.collections.push(collection);
    }
};

StickersBook2.prototype.updateInfo = function (serverData) {
    if (!serverData) {
        return;
    }

    this.load(serverData);
    this.save(true);
};

StickersBook2.prototype.updateAttention = function (data) {
    this.collections.forEach((collection, index) => {
        const info = this.binaryToArray(index < data.length ? data[index] : 0, StickersCollection2.STICKERS_IN_COLLECTION);
        collection.updateAttention(info);
    });
};

StickersBook2.prototype.getAvailableCollections = function () {
    return this.collections;
};

StickersBook2.prototype.getInfo = function () {
    const collectionsInfo = this.getAvailableCollections().map((collection) => collection.getInfo());
    return {
        season: this.season,
        collections: collectionsInfo.map((info) => {
            info.stickers.push(info.isPrizeCollected ? 1 : 0);
            return this.arrayToBinary(info.stickers);
        }),
        points: this.points,
        restarts: this.restarts,
        finished: this.finished ? 1 : 0,
        version: this.version
    };
};

StickersBook2.prototype.getAttentionInfo = function () {
    return this.collections.map((collection) => this.arrayToBinary(collection.getAttentionInfo()));
};

StickersBook2.prototype.arrayToBinary = function (array) {
    return array.reduce((acc, curr) => (acc << 1) | curr, 0);
};

StickersBook2.prototype.binaryToArray = function (binary, length) {
    const array = [];
    for (let i = 0; i < length; i++) {
        array.unshift(binary & 1);
        binary >>= 1;
    }
    return array;
};

StickersBook2.prototype.createRarityPool = function () {
    const pool = Array.from({ length: StickersCollection2.DROP_PROBABILITIES.length }, () => []);

    this.getAvailableCollections().forEach((collection) => {
        collection.stickers.forEach((sticker) => {
            pool[sticker.rarity].push(sticker);
        });
    });

    return pool;
};

StickersBook2.prototype.rollSticker = function (pool, filter) {
    filter = filter || {};

    const buckets = pool.map((stickers, rarity) => {
        if (filter.minRarity && rarity < filter.minRarity) {
            return [];
        }
        return filter.closedOnly ? stickers.filter((sticker) => sticker.getState() === Sticker2.STATE_CLOSED) : stickers;
    });

    const probabilities = StickersCollection2.DROP_PROBABILITIES;
    const sum = buckets.reduce((total, stickers, rarity) => total + (stickers.length ? probabilities[rarity] : 0), 0);
    if (!sum) {
        return undefined;
    }

    let flipCoin = PseudoRandom.GET().nextDouble() * sum;
    for (let rarity = 0; rarity < buckets.length; rarity++) {
        if (buckets[rarity].length) {
            flipCoin -= probabilities[rarity];
            if (flipCoin < 0) {
                return PseudoRandom.GET().choose(buckets[rarity]);
            }
        }
    }
    return undefined;
};

StickersBook2.prototype.chooseRarestClosed = function (pool) {
    for (let rarity = pool.length - 1; rarity >= 0; rarity--) {
        const closed = pool[rarity].filter((sticker) => sticker.getState() === Sticker2.STATE_CLOSED);
        if (closed.length) {
            return PseudoRandom.GET().choose(closed);
        }
    }
    return undefined;
};

StickersBook2.prototype.rollPityNew = function () {
    const counter = cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK2_PITY) || 0;
    return counter >= 2 && PseudoRandom.GET().nextDouble() < Math.min((counter - 1) / 3, 1);
};

StickersBook2.prototype.updatePityCounter = function (gotNew) {
    const counter = cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK2_PITY) || 0;
    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK2_PITY, gotNew ? 0 : counter + 1);
};

StickersBook2.prototype.collectSticker = function (sticker, sourceEvent) {
    this.newStickers.push(sticker);

    if (sticker.getState() === Sticker2.STATE_OPENED) {
        this.incPoints(sticker.getStarsAmount());
        sticker.duplicate = true;
        return false;
    }

    sticker.open(sourceEvent);
    return true;
};

StickersBook2.prototype.givePrize = function (amount, sourceEvent, options) {
    options = options || {};
    this.newStickers = this.newStickers || [];

    const pool = this.createRarityPool();
    const pityNew = options.pity && this.rollPityNew();

    let duplicates = 0;
    let newAmount = 0;

    for (let i = 0; i < amount; i++) {
        const isFirst = i === 0;
        const isLast = i === amount - 1;

        let sticker;
        if (isLast && options.guaranteedNew) {
            sticker = this.chooseRarestClosed(pool);
        }
        if (!sticker && isLast && pityNew && !newAmount) {
            sticker = this.rollSticker(pool, { closedOnly: true });
        }
        if (!sticker && isFirst && options.firstCardMinRarity) {
            sticker = this.rollSticker(pool, { minRarity: options.firstCardMinRarity });
        }
        if (!sticker) {
            sticker = this.rollSticker(pool) || PseudoRandom.GET().choose(pool[0]);
        }

        if (this.collectSticker(sticker, sourceEvent)) {
            newAmount++;
        } else {
            duplicates++;
        }
    }

    if (options.pity) {
        this.updatePityCounter(newAmount > 0);
    }

    if (duplicates > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STICKER2_DUPLICATE + sourceEvent, { value: duplicates });
    }

    this.newStickers = this.newStickers.sort((a, b) => (b.rarity < a.rarity ? -1 : 1));
};

StickersBook2.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK2_INFO, this.getInfo());
    if (!fromServer) {
        connector.synchronizer.addSendTask("stickersbook2");
    }

    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK2_ATTENTION, this.getAttentionInfo());
};

StickersBook2.prototype.getOpenedStickersAmount = function () {
    let amount = 0;
    this.getAvailableCollections().forEach((collection) => {
        amount += collection.getOpenedStickersAmount();
    });
    return amount;
};

StickersBook2.prototype.getCompletedCollectionsAmount = function () {
    return this.collections.filter((collection) => collection.isCompleted).length;
};

StickersBook2.prototype.isCompleted = function () {
    return this.collectionsAmount > 0
        && this.collections.filter((collection) => collection.isCollected()).length === this.collectionsAmount;
};

StickersBook2.prototype.incPoints = function (amount) {
    this.points += amount;
    this.trigger("updatePoints");
    this.save();
};

StickersBook2.prototype.canSpendPoints = function (amount) {
    if (this.points < amount) {
        cleverapps.notification.create(Messages.get("StickersShopWindow2.NotEnoughPoints"));
        return false;
    }

    return true;
};

StickersBook2.prototype.spendPoints = function (eventName, amount) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.SPENT.STICKERS2_POINTS, { value: amount, itemId: eventName });

    this.points -= amount;
    this.trigger("updatePoints");
    this.save();
};

StickersBook2.prototype.getTotalStickersAmount = function () {
    return this.collectionsAmount * StickersCollection2.STICKERS_IN_COLLECTION;
};

// Each pass through the book has its own main prize and, where the season lists them, its own
// landmark. A season that ever allows more passes than the config lists keeps giving the last one.
StickersBook2.prototype.getMainPrize = function () {
    const prizes = RewardsConfig.StickersBook2MainPrize;
    const prize = prizes[Math.min(this.restarts, prizes.length - 1)];

    const landmarks = RewardsConfig.StickersBook2Landmarks && RewardsConfig.StickersBook2Landmarks[this.season];
    if (!landmarks) {
        return prize;
    }

    const stage = landmarks[Math.min(this.restarts, landmarks.length - 1)];
    return { ...prize, unit: [{ code: "landmark", stage }].concat(cleverapps.toArray(prize.unit) || []) };
};

StickersBook2.isLandmarkReward = function (reward) {
    return reward.type === "units" && reward.value && typeof Families !== "undefined"
        && Families[reward.value.code] && Families[reward.value.code].type === "landmark";
};

StickersBook2.findLandmarkUnit = function () {
    if (typeof Map2dLocation === "undefined" || !Map2dLocation.currentLocation || !Map2d.currentMap || !cleverapps.achievements) {
        return undefined;
    }

    const landmarks = Map2dLocation.currentLocation.landmarks;
    if (!landmarks || landmarks.listWindowLandmarks().length === 0) {
        return undefined;
    }

    const deployed = landmarks.listDeployed();
    if (deployed.length > 0) {
        return deployed[0];
    }

    const spot = landmarks.findLocation();
    return spot && Map2d.currentMap.getUnit(spot.x, spot.y);
};

StickersBook2.getMainPrizeLandmark = function () {
    if (!cleverapps.stickersBook2 || !cleverapps.stickersBook2.isAvailable()) {
        return undefined;
    }

    const reward = new RewardsList(cleverapps.stickersBook2.getMainPrize()).listRewards()
        .find((reward) => StickersBook2.isLandmarkReward(reward));

    return reward && reward.value;
};

StickersBook2.isMainPrizeLandmark = function (unit) {
    const landmark = StickersBook2.getMainPrizeLandmark();
    return Boolean(landmark) && Unit.IsApplicable(landmark, unit);
};

StickersBook2.openBookWindow = function () {
    cleverapps.focusManager.display({
        focus: "StickersBook2",
        stack: true,
        action: (f) => {
            cleverapps.focusManager.onceNoWindowsListener = f;
            new StickersBookWindow2(cleverapps.stickersBook2);
        }
    });
};

StickersBook2.prototype.hasAttention = function () {
    return this.collections.filter((collection) => collection.hasAttention()).length;
};

StickersBook2.isPuzzle = function () {
    return ["wooden"].includes(cleverapps.config.ui);
};

StickersBook2.prototype.getUnissuedPrizes = function () {
    if (!this.isEnoughBundlesForSeason() && this.unissuedPrizesCollectionsIndexes.length) {
        return this.unissuedPrizesCollectionsIndexes.map((collectionIndex) => StickersBook2.getCollectionReward(collectionIndex));
    }

    const collectionPrizes = this.collections
        .filter((collection) => collection.isCompleted && !collection.isPrizeCollected)
        .map((collection) => StickersBook2.getCollectionReward(collection.index));

    return (this.isCompleted() ? [this.getMainPrize()] : []).concat(collectionPrizes);
};

StickersBook2.getCollectionReward = function (collectionIndex) {
    return RewardsConfig.StickersBook2[collectionIndex % RewardsConfig.StickersBook2.length];
};

StickersBook2.prototype.calcCollectionsAmount = function () {
    let collectionsAmount = 0;
    while (SeasonCollectionsHelper2.hasCollectionBundle(collectionsAmount, this.season)) {
        collectionsAmount++;
    }

    return collectionsAmount;
};

StickersBook2.prototype.getLevelReward = function () {
    const StickersBookLevelRewards = {
        "hard": 3,
        "default": 1
    };
    return Game.currentGame.getNormalizedLevelReward(StickersBookLevelRewards, "match3");
};

StickersBook2.prototype.calcSeasonIndex = function () {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const seasonIndex = Math.floor(month / StickersBook2.MONTHS_PER_SEASON);

    return `${year}_${seasonIndex}`;
};

StickersBook2.prototype.getSeasonTimeLeft = function () {
    if (!this.season) {
        return;
    }

    const now = new Date();

    const [yearStr, seasonStr] = this.season.split("_");
    const year = parseInt(yearStr, 10);
    const season = parseInt(seasonStr, 10);

    const startMonth = season * StickersBook2.MONTHS_PER_SEASON;
    const endMonth = startMonth + StickersBook2.MONTHS_PER_SEASON;

    const endDate = new Date(year, endMonth, 1);

    return endDate.getTime() - now.getTime();
};

StickersBook2.prototype.collectionBundle = function (collectionIndex) {
    return SeasonCollectionsHelper2.getCollectionBundleName(collectionIndex, this.season);
};

StickersBook2.MONTHS_PER_SEASON = 2;

StickersBook2.PRODUCTS = ["stickers2_3", "stickers2_4", "stickers2_5", "stickers2_2", "stickers2_1", "stickers2_0"];

StickersBook2.PACKS = {
    stickers2BrownPack: { amount: 2, icon: "stickers2_brown_pack_png" },
    stickers2GreenPack: { amount: 3, icon: "stickers2_green_pack_png" },
    stickers2BluePack: { amount: 4, icon: "stickers2_blue_pack_png" },
    stickers2VioletPack: {
        amount: 6,
        firstCardMinRarity: 2,
        pity: true,
        icon: "stickers2_violet_pack_png"
    },
    stickers2RedPack: { amount: 6, guaranteedNew: true, icon: "stickers2_red_pack_png" }
};

cleverapps.InitByFeature["season_collections2"] = function () {
    cleverapps.stickersBook2 = new StickersBook2();

    if (cleverapps.toolModel) {
        ToolModel.AUTONAVIGATE.push({
            windows: ["StickersBook2"],
            path: ["stickersBook2"]
        });
    }

    cleverapps.tutorial.register(StickersBookStartTutorial2());
    cleverapps.tutorial.register(SeasonCollectionsStartTutorial2());
};

StickersBook2.STICKER_POSITION = {
    x: { align: "center" },
    y: { align: "center" }
};
